import * as svg from "../../../assets/home.svg";

import {iconBuilder} from "./iconBuilder";

const HomeIcon = iconBuilder(svg, "HomeIcon", "0 0 18 19");

export default HomeIcon;
